// extracted by mini-css-extract-plugin
export default {"shadowed":"Terminal_shadowed__lFFoO","terminal":"Terminal_terminal__YWKw0","changeColors":"Terminal_changeColors__9o4ok"};